(function () {
  const STORAGE_KEY = 'ulpQuoteItems';

  function readItems() {
    try {
      const items = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return Array.isArray(items) ? items : [];
    } catch (error) {
      return [];
    }
  }

  function writeItems(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    updateQuoteCount();
  }

  function parseJson(value) {
    if (!value) return null;
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function getSelectedVariant(productInfo, button) {
    const selectedVariant = productInfo?.querySelector('variant-selects [data-selected-variant]');
    return parseJson(selectedVariant?.textContent) || parseJson(button.dataset.defaultVariant);
  }

  function getQuantity(productInfo) {
    const input = productInfo?.querySelector('.quantity__input');
    const quantity = parseInt(input?.value, 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function getItemKey(item) {
    return String(item.variantId || item.productId);
  }

  function getOptionText(item) {
    if (!item.options || !item.options.length) return '';
    if (item.options.length === 1 && item.options[0] === 'Default Title') return '';
    return item.options.join(' / ');
  }

  function buildSummary(items) {
    if (!items.length) return '';

    const lines = ['Quote Request Items:'];
    items.forEach((item, index) => {
      lines.push('');
      lines.push(`${index + 1}. ${item.productTitle}`);
      const optionText = getOptionText(item);
      if (optionText) lines.push(`Variant: ${optionText}`);
      if (item.sku) lines.push(`SKU: ${item.sku}`);
      lines.push(`Quantity: ${item.quantity}`);
      lines.push(`Product URL: ${window.location.origin}${item.productUrl}`);
    });

    return lines.join('\n');
  }

  function updateQuoteCount() {
    const count = readItems().length;
    document.querySelectorAll('[data-quote-label]').forEach((label) => {
      label.textContent = count > 0 ? `QUOTE (${count})` : 'QUOTE';
    });
    document.querySelectorAll('[data-quote-count]').forEach((bubble) => {
      bubble.textContent = count > 0 ? count : '';
      bubble.classList.toggle('hidden', count === 0);
    });
  }

  function addQuoteItem(button) {
    const productInfo = button.closest('product-info');
    const variant = getSelectedVariant(productInfo, button);
    if (!variant || !variant.id) return;

    const quantity = getQuantity(productInfo);
    const newItem = {
      productId: button.dataset.productId,
      productTitle: button.dataset.productTitle,
      productHandle: button.dataset.productHandle,
      productUrl: button.dataset.productUrl,
      productVendor: button.dataset.productVendor,
      productImage: button.dataset.productImage,
      variantId: variant.id,
      variantTitle: variant.title,
      options: variant.options || [],
      sku: variant.sku || '',
      price: variant.price,
      quantity,
    };

    const items = readItems();
    const existingItem = items.find((item) => getItemKey(item) === getItemKey(newItem));

    if (existingItem) {
      existingItem.quantity += quantity;
    } else {
      items.push(newItem);
    }

    writeItems(items);
    renderQuotePage();

    const status = button.closest('.quote-product-actions')?.querySelector('[data-quote-add-status]');
    if (status) {
      status.innerHTML = 'Added to quote. <a href="/pages/quote">View quote</a>';
      window.setTimeout(() => {
        status.textContent = '';
      }, 5000);
    }
  }

  function createItemElement(item, index) {
    const wrapper = document.createElement('article');
    wrapper.className = 'quote-request__item';

    const image = document.createElement('img');
    image.className = 'quote-request__image';
    image.alt = '';
    image.loading = 'lazy';
    if (item.productImage) {
      image.src = item.productImage;
    }

    const body = document.createElement('div');

    const title = document.createElement('a');
    title.className = 'quote-request__item-title';
    title.href = item.productUrl;
    title.textContent = item.productTitle;

    const meta = document.createElement('p');
    meta.className = 'quote-request__meta';
    const optionText = getOptionText(item);
    meta.textContent = [optionText, item.sku ? `SKU: ${item.sku}` : ''].filter(Boolean).join(' | ');

    const controls = document.createElement('div');
    controls.className = 'quote-request__item-controls';

    const quantity = document.createElement('input');
    quantity.className = 'field__input quote-request__qty';
    quantity.id = `QuoteItemQty-${index}`;
    quantity.type = 'number';
    quantity.min = '1';
    quantity.setAttribute('aria-label', `Quantity for ${item.productTitle}`);
    quantity.value = item.quantity;
    quantity.dataset.quoteQuantity = String(index);

    const remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'link underlined-link quote-request__remove';
    remove.dataset.quoteRemove = String(index);
    remove.textContent = 'Remove';

    controls.append(quantity, remove);
    body.append(title, meta, controls);
    wrapper.append(image, body);

    return wrapper;
  }

  function renderQuotePage() {
    const list = document.querySelector('[data-quote-items]');
    const empty = document.querySelector('[data-quote-empty]');
    const clear = document.querySelector('[data-quote-clear]');
    const summary = document.querySelector('[data-quote-summary]');
    if (!list || !summary) return;

    const items = readItems();
    list.replaceChildren(...items.map(createItemElement));
    empty?.toggleAttribute('hidden', items.length > 0);
    clear?.toggleAttribute('hidden', items.length === 0);
    summary.value = buildSummary(items);
  }

  document.addEventListener('click', (event) => {
    const addButton = event.target.closest('[data-quote-add]');
    if (addButton) {
      event.preventDefault();
      addQuoteItem(addButton);
      return;
    }

    const removeButton = event.target.closest('[data-quote-remove]');
    if (removeButton) {
      const items = readItems();
      items.splice(Number(removeButton.dataset.quoteRemove), 1);
      writeItems(items);
      renderQuotePage();
      return;
    }

    if (event.target.closest('[data-quote-clear]')) {
      writeItems([]);
      renderQuotePage();
    }
  });

  document.addEventListener('change', (event) => {
    const quantityInput = event.target.closest('[data-quote-quantity]');
    if (!quantityInput) return;

    const items = readItems();
    const index = Number(quantityInput.dataset.quoteQuantity);
    const quantity = parseInt(quantityInput.value, 10);

    if (items[index] && Number.isFinite(quantity) && quantity > 0) {
      items[index].quantity = quantity;
      writeItems(items);
      renderQuotePage();
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('#QuoteRequestForm, #ContactForm');
    if (!form || !form.querySelector('[data-quote-summary]')) return;

    const error = form.querySelector('[data-quote-error]');
    const summary = form.querySelector('[data-quote-summary]');
    const items = readItems();
    if (summary) summary.value = buildSummary(items);

    if (!items.length) {
      event.preventDefault();
      if (error) error.textContent = 'Please add at least one product to your quote before submitting.';
    } else if (error) {
      error.textContent = '';
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    updateQuoteCount();
    renderQuotePage();
  });

  document.addEventListener('shopify:section:load', () => {
    updateQuoteCount();
    renderQuotePage();
  });
})();
